module.exports = __webpack_public_path__ + "assets/img/poster.7b94ee23.png";